import { CroustilleElement } from "../lib";

function scollItemToTop(item) {
  item.scrollIntoView({
    // behavior: "smooth"
  });
}

function restoreSizes(item) {
  const imgs = item.querySelectorAll('[sizes]')

  imgs.forEach(img => {
    img.sizes = img.dataset.sizes
    delete img.dataset.sizes
  })
}

function changeSizesToContainerWidth(item, container) {
  const imgs = item.querySelectorAll('[sizes]')

  const width = container.offsetWidth

  imgs.forEach(img => {
    img.dataset.sizes = img.sizes
    img.sizes = `${width}px`
  })
}

class Images extends CroustilleElement {
  constructor() {
    super('images')
  }

  get items() {
    return this.children('item')
  }

  toggle(item) {
    if (item.classList.contains('active')) {
      item.classList.remove('active')
      restoreSizes(item)
    } else {
      item.classList.add('active')
      changeSizesToContainerWidth(item, this.node)
    }
    scollItemToTop(item)
  }

  handleClick(e, item) {
    e.preventDefault()
    if (window.screen.width > 767) {
      this.toggle(item)
    }
  }

  init() {
    this.handleClick = this.handleClick.bind(this)
    this.items.forEach((item) => {
      item.addEventListener('click', (e) => this.handleClick(e, item))
    })
  }
}

export default Images
